interface WithPosition {
  position: number;
}

export default function sortByPosition(a: WithPosition, b: WithPosition): number {
  if (a.position < b.position) return -1;
  if (a.position > b.position) return 1;
  return 0;
}
